/*

    Форма авторизации
*/

import React , { useState } from 'react';

import './Authorize.css';
import axios_sender from '../modules/axios_sender';
import { ClearGlobalAnimal } from '../modules/animal.js';
import { ClearGlobalClient } from '../modules/client.js';

import { getWorkerType, addWorker, clearWorker } from '../modules/workers';



function Authorize({onAuthorize}) {

  const [user_login, setUserLogin] = useState('');     // логин
  const [user_password, setUserPassword] = useState('');     // логин

//#region   
  return (
    <div className="d-flex justify-content-center border border-1 rounded">
      <div className="Authorize">
          
        <label className="form-label mb-1">Авторизация</label>

        <div className="input-group mb-1">
          <span className="input-group-text col-3">Логин</span>
          <input type="text" className="form-control" value={ user_login } onChange={(event) => setUserLogin(event.target.value)} />
        </div>
        <div className="input-group mb-1">
          <span className="input-group-text col-3">Пароль</span>
          <input type="password" className="form-control" value={ user_password } onChange={(event) => setUserPassword(event.target.value)} />
        </div>

        <div className="input-group mb-1">
          <button type="button" className="btn btn-secondary col-5" >Отмена</button>
          <div className="col-2"></div>
          <button type="button" className="btn btn-secondary col-5" onClick={ AuthorizeSender }>ОК</button>
        </div>


      </div>
 
    </div>
//#endregion
  );


  function AuthorizeSender()
  {
    axios_sender({form: 'authorization', login: user_login, password: user_password}, AuthorizeSenderSuccess);
  }
  function AuthorizeSenderSuccess(data)
  {
      if(data.id > 0)
      {            
        onAuthorize(true);
        localStorage.setItem('id_user', data.id);
        localStorage.setItem('user_name', data.name);
        localStorage.setItem('token', data.token);
        localStorage.setItem('rights', data.rights);
        localStorage.setItem('type', data.type);


        // найдём первое ID клиники
        let rights = data.rights.split(',');
        for(var i in rights)
          if(rights[i].includes('clinic_id_'))
          {
              let cid = rights[i].trim().substring("clinic_id_".length);
              localStorage.setItem('clinic_id', cid);
              break;
          }        


        // определим врач или ассистент или админ
        let work_type = getWorkerType(data);

        // очистим список выделенных и выделим текущего пользователя
        clearWorker();
        addWorker(data.id, data.name, work_type);
        
        // очистим выделенного клиента и животное
        ClearGlobalClient();
        ClearGlobalAnimal();

      }
      else
      {
        localStorage.clear();
      }
  }
  
}



export default Authorize;
